import axios from 'axios'

import router from '../router'
import store from '../store'
import Vue18nCustomPlugin from './Vue18nCustomPlugin'

// Precedence: VITE_API_URL (incl. empty string = same-origin / Vite
// proxy mode) → window.config.api_url from bootstrap → empty.
const apiBaseURL = import.meta.env?.VITE_API_URL !== undefined
  ? import.meta.env.VITE_API_URL
  : (window.config?.api_url || '')
axios.defaults.baseURL = apiBaseURL
axios.defaults.withCredentials = Boolean(apiBaseURL)

// Request interceptor. `headers.common.X = Y` is the axios v0.x shape;
// in axios v1 it serialises as a literal `Common` header which breaks
// CORS preflight — set headers directly instead.
axios.interceptors.request.use(request => {
  const token = store.getters['auth/token']
  if (token) {
    request.headers.Authorization = `Bearer ${token}`
  }

  const locale = store.getters['lang/locale']
  if (locale) {
    request.headers['Accept-Language'] = locale
  }

  request.headers['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone

  return request
})

// Response interceptor
axios.interceptors.response.use(response => response, error => {
  const status = error.response?.status
  const i18n = Vue18nCustomPlugin.getInstance()

  if (status >= 500) {
    console.error('Server error:', i18n.t('ui.public.error_alert_title'), i18n.t('ui.public.error_alert_text'))
  }

  if (status === 401 && store.getters['auth/check']) {
    store.commit('auth/LOGOUT')

    router.push({ name: 'login' })
  }

  return Promise.reject(error)
})
